import React from 'react';

const NoValue = ({text = '-'}) => {
    return <span className="text-muted">{text}</span>
}

export default NoValue;
